import {ContentfulCards} from '@github-ui/swp-core/components/contentful/ContentfulCards'
import type {PrimerCards} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerCards'

import {Section} from '../../../../../brand/components/BrandPage'
import type {GenericSectionWithIds} from '../../../../../brand/lib/types/contentful'

import styles from './ResourcesSection.module.css'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function ResourcesSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro, content} = contentfulContent.fields

  const cardsComponent =
    (content?.find(item => item.sys.contentType.sys.id === 'primerCards') as PrimerCards) || undefined

  return (
    <Section id="resources" introComponent={sectionIntro} withBorder>
      {cardsComponent ? <ContentfulCards component={cardsComponent} className={styles.cards} fullWidth /> : null}
    </Section>
  )
}

try{ ResourcesSection.displayName ||= 'ResourcesSection' } catch {}